import type {
  ContentAsset,
  ContentSession,
} from '@/src/queries/library-queries'

import { resolveMediaAspectRatio } from './media-aspect-ratio'

const SESSION_DEFAULT_VIDEO_ASPECT_RATIO = 16 / 9
const SESSION_DEFAULT_MEDIA_ASPECT_RATIO = 9 / 16

export function normalizeSessionParam(value: string | string[] | undefined) {
  if (Array.isArray(value)) return value[0]
  return value
}

export function resolveSessionSource(value: string | string[] | undefined) {
  const source = normalizeSessionParam(value)
  if (source === 'preview' || source === 'library') return source
  return 'session'
}

export function buildSessionStepKeys(
  steps: ContentSession['steps'] | undefined,
) {
  return (steps ?? []).map((step, idx) => step.id ?? `session-step-${idx}`)
}

export function resolveInitialVisualAspectRatio({
  isVideo,
  isWeb,
  visualMedia,
}: {
  isVideo: boolean
  isWeb: boolean
  visualMedia: ContentAsset | null | undefined
}) {
  const fallbackAspectRatio = isVideo
    ? isWeb
      ? SESSION_DEFAULT_MEDIA_ASPECT_RATIO
      : SESSION_DEFAULT_VIDEO_ASPECT_RATIO
    : SESSION_DEFAULT_MEDIA_ASPECT_RATIO
  const details = visualMedia?.details
  const initialWidth = details?.image?.width ?? details?.video?.width
  const initialHeight = details?.image?.height ?? details?.video?.height

  if (initialWidth == null || initialHeight == null) {
    return {
      fallbackAspectRatio,
      initialAspectRatio: fallbackAspectRatio,
    }
  }

  return {
    fallbackAspectRatio,
    initialAspectRatio: resolveMediaAspectRatio({
      width: initialWidth,
      height: initialHeight,
      isVideo,
      isWeb,
      fallbackAspectRatio,
    }),
  }
}
